module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_9005.e0536560.png";